import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { loginSuccess } from "../../redux/Authentication";
import { post } from "../../services/ApiService";
import "../custom-style.css";

const MFA = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const tempToken = location.state?.tempToken;
    const isNewUser = location.state?.isNewUser;
    const [otp, setOtp] = useState("");
    const [verifying, setVerifying] = useState(false);
    const [resending, setResending] = useState(false);

    if (!tempToken) {
        navigate("/login", { replace: true });
        return null;
    }

    const handleVerify = async (e) => {
        e.preventDefault();
        if (!otp.trim()) {
            toast.error("Enter the code from your email");
            return;
        }
        try {
            setVerifying(true);
            const res = await post("api/auth/verify-mfa", { tempToken, otp });
            if (res.success) {
                toast.success("Verified");
                dispatch(loginSuccess(res.user));
                if (res.user?.isNewUser || isNewUser) {
                    navigate("/change-password");
                } else {
                    navigate("/");
                }
            } else {
                toast.error(res.error || "Verification failed");
            }
        } catch (err) {
            console.error(err);
            toast.error("Verification failed. Please try again.");
        } finally {
            setVerifying(false);
        }
    };

    const handleResend = async () => {
        try {
            setResending(true);
            const res = await post("api/auth/resend-mfa", { tempToken });
            if (res.success) {
                toast.success("New code sent to your email");
            } else {
                toast.error(res.error || "Could not resend code");
            }
        } catch (err) {
            console.error(err);
            toast.error("Could not resend code");
        } finally {
            setResending(false);
        }
    };

    return (
        <>
            <Toaster position="top-center" reverseOrder={false} />
            <main id="content" className="wrapper layout-page">
                <section className="pb-lg-20 pb-16">
                    <div className="container">
                        <div className="text-center pt-13 mb-12 mb-lg-15">
                            <h2 className="fs-36px mb-11 mb-lg-14">Two-factor authentication</h2>
                            <p className="text-muted">We sent a one-time code to your email. Enter it below to continue.</p>
                        </div>
                        <div className="row no-gutters">
                            <div className="col-lg-6 col-md-8 mx-auto">
                                <form onSubmit={handleVerify}>
                                    <div className="form-group mb-6">
                                        <label htmlFor="otp" className="visually-hidden">One-time code</label>
                                        <input
                                            type="text"
                                            inputMode="numeric"
                                            autoComplete="one-time-code"
                                            className="form-control"
                                            id="otp"
                                            placeholder="Enter 6-digit code"
                                            value={otp}
                                            onChange={(e) => setOtp(e.target.value.replace(/\s+/g, ""))}
                                            required
                                        />
                                    </div>
                                    <button type="submit" className="btn btn-primary w-100 mb-4" disabled={verifying}>
                                        {verifying && <i className="fa fa-spinner fa-spin me-2"></i>} Verify
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-link w-100"
                                        onClick={handleResend}
                                        disabled={resending}
                                    >
                                        {resending ? "Sending…" : "Resend code"}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
};

export default MFA;
